import { PropsWithChildren } from 'react';
import { SocketContext } from '@/shared/api';
import { useSocketGlobalConnection } from './useSocketGlobalConnection';
import { useSocketGlobalListener } from './useSocketGlobalListener';

export const SocketProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const connection = useSocketGlobalConnection();
  useSocketGlobalListener(connection.socket);

  return (
    <SocketContext.Provider value={connection}>
      {children}
    </SocketContext.Provider>
  );
};
